import styled from "styled-components";

const SIDEBAR_WIDTH = "200px";

export const Wrapper = styled("div")`
  background: #ffffff;
  min-height: 100vh;
`;

export const Content = styled("div")`
  display: flex;
`;

export const DataContent = styled("div")`
  padding: 0 24px;
  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const Container = styled("div")`
  width: calc(100% - ${SIDEBAR_WIDTH});
  min-height: 100vh;
  background: #ffffff;
  margin-left: ${SIDEBAR_WIDTH};
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const Overlay = styled("div")`
  display: none;
  @media (max-width: 768px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
  }
`;
